// Order History Utility Functions
import {
  formatDateForAPI,
  formatDateTimeInTimezone,
  getDateStringInTimezone,
  getRestaurantTimezone,
} from "../../../utils/dateTimeUtils";

export { formatDateForAPI };

export const normalizeOrderType = (type) => {
  if (!type || typeof type !== "string") return "";
  return type.toLowerCase().replace(/[_-]/g, " ").trim();
};

export const getLocalDateString = (dateStr, timezone) =>
  getDateStringInTimezone(dateStr, getRestaurantTimezone(timezone));

export const formatOrderType = (type) => {
  if (!type) return "-";

  let normalized = type.toLowerCase().replace(/[_-]/g, " ").trim();

  if (normalized === "dinein") {
    normalized = "dine in";
  }

  if (normalized.includes("qr")) {
    return "QR Order";
  }

  return normalized.replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatOrderedTime = (dateStr, timezone) => {
  if (!dateStr) return "-";
  return formatDateTimeInTimezone(dateStr, timezone);
};

export const countByStatus = (orders, status) =>
  orders.filter(
    (o) => o.status?.trim().toLowerCase() === status.trim().toLowerCase(),
  ).length;

export const getTotalSales = (orders) =>
  orders.reduce((sum, order) => sum + Number(order.amount || 0), 0);
